import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { Text, Box, TextButton } from 'wix-style-react';
import { DataHooks } from '../../constants/data-hooks';
import { SectionComponent } from '../section.component.tsx/section.component';
import { navigateTo, PageComponentId } from '@wix/business-manager-api';

import * as css from './visitor-data.scss';
import { AppContext } from '@src/context/store';
import { getKBLinks } from '@src/context/selectors/ui-settings';

const dataRequestClicked = () => {
  navigateTo({
    pageComponentId: PageComponentId.Contacts,
    contextData: {
      appState: 'gdpr',
    },
  });
};

const consentLogClicked = () => {
  navigateTo({
    pageComponentId: PageComponentId.CookieConsentBannerSettings,
    contextData: {
      appState: 'consent-log',
    },
  });
};

export const VisitorDataComponent = translate()(({ t }: InjectedTranslateProps) => {
  const store = React.useContext(AppContext);
  const onLearnMoreClicked = () => window.open(getKBLinks(store).AboutPrivacyCookies, '_blank');

  return (
    <Box dataHook={DataHooks.VisitorData} direction={'vertical'}>
      <Box marginBottom={'24px'}>
        <Text dataHook={DataHooks.VisitorDataDescription}>
          {t('visitor.data.description')}
          <TextButton className={css.textButton} onClick={onLearnMoreClicked}>
            {t('here')}
          </TextButton>
        </Text>
      </Box>
      <SectionComponent
        className={css.section}
        dataHook={DataHooks.VisitorDataDataRequest}
        title={t('visitor.data.data.request.title')}
        subtitle={t('visitor.data.data.request.subtitle')}
        actionHasIcon={true}
        onButtonClicked={dataRequestClicked}
      />
      <SectionComponent
        className={css.section}
        dataHook={DataHooks.VisitorDataConsentLog}
        title={t('visitor.data.consent.log.title')}
        subtitle={t('visitor.data.consent.log.subtitle')}
        actionHasIcon={true}
        onButtonClicked={consentLogClicked}
      />
    </Box>
  );
});
